
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';

// Find root element or create one if it doesn't exist
const rootElement = document.getElementById("root") || (() => {
  const element = document.createElement("div");
  element.id = "root";
  document.body.appendChild(element);
  return element;
})();

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
